import { Component, OnInit } from '@angular/core';
import {CountriesSearch} from '../../models/countries-search.interface';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {CountriesService} from '../../services/countries.service';
import {Countries} from '../../models/countries.interface';
import {Page} from '../../../shared/models/page.interface';
import {MessageService} from '../../../shared/services/message.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-countries',
  templateUrl: './countries.component.html',
  styleUrls: ['./countries.component.scss']
})
export class CountriesComponent implements OnInit {

  upload!: boolean;
  message = this.router.getCurrentNavigation()?.extras?.state?.message;
  countries!: Page<Countries>;
  private search!: CountriesSearch;
  private page: PageRequest = {page: 0, size: 100, sort: 'code', direction: 'asc'};

  constructor(private readonly countriesService: CountriesService,
              private messageService: MessageService,
              private readonly router: Router) {
    this.upload = this.router.url.includes('upload');
  }

  ngOnInit(): void {
    this.countriesService.getAll({status: 2}, this.page).subscribe(
      data => this.countries = data
    );
    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
  }

  loadCountries(event: PageRequest): void {
    this.page = event;
    if (this.search) {
      this.countriesService.getAll(this.search, event).subscribe(
        data => this.countries = data
      );
    }
    else {
      this.countriesService.getAll({status: 2}, event).subscribe(
        data => this.countries = data
      );
    }
  }

  searchCountries(search: CountriesSearch): void {
    this.search = search;
    if (Object.keys(search).length === 0) {
      this.page = {page: 0, size: 100, sort: 'code', direction: 'asc'};
    }
    this.countriesService.getAll(search, this.page).subscribe(
      data => this.countries = data
    );
  }

  updateCountryStatus(id: number): void {
    this.countriesService.updateCountry(id).subscribe(
      () => this.updateData()
    );

  }

  deleteCountry(id: number): void {
    this.countriesService.deleteCountry(id).subscribe(
      () => this.updateData()
    );
  }

  private updateData(): void {
    if (this.search) {
      this.countriesService.getAll(this.search, this.page).subscribe(
        data => this.countries = data
      );
    }
    else {
      this.countriesService.getAll({status: 2}, this.page).subscribe(
        data => this.countries = data
      );
    }
  }

}
